var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultTeamLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#21A19A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7193,
    cy: 12.852,
    r: 3.18535,
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6668 20.4676C10.6659 20.2437 10.716 20.0225 10.8132 19.8207C11.1183 19.2105 11.9787 18.8871 12.6927 18.7407C13.2076 18.6308 13.7296 18.5574 14.2549 18.521C15.2273 18.4356 16.2054 18.4356 17.1778 18.521C17.703 18.5578 18.225 18.6312 18.74 18.7407C19.4539 18.8871 20.3144 19.18 20.6195 19.8207C20.815 20.2319 20.815 20.7093 20.6195 21.1205C20.3144 21.7613 19.4539 22.0542 18.74 22.1945C18.2257 22.3089 17.7035 22.3844 17.1778 22.4203C16.3863 22.4874 15.5911 22.4996 14.798 22.4569C14.6149 22.4569 14.4379 22.4569 14.2549 22.4203C13.7312 22.3849 13.211 22.3094 12.6988 22.1945C11.9787 22.0542 11.1244 21.7613 10.8132 21.1205C10.7165 20.9165 10.6664 20.6934 10.6668 20.4676Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTeamLogo);
export default __webpack_public_path__ + "static/media/defaultTeamLogo.b32939f3a3f5c798a7d7db6253a0a5bc.svg";
export { ForwardRef as ReactComponent };